import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/brandAPP.png';
import _imports_1 from '@/assets/brand.png';
const _withScopeId = n => (_pushScopeId("data-v-084ea844"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top text-[#9faab4] !bg-[#1C1C27] leading-[34px]"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "content pb-[20px] pt-[60px]"
};
const _hoisted_4 = {
  class: "mx-[10px] mb-[10px] bg-[rgba(0,0,0,0.50)] rounded-[50px] px-[34px] py-[7px] flex items-center"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-[50px] h-[50px]"
})], -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-[61px] h-[30px]"
}, null, -1));
const _hoisted_7 = {
  class: "w-[210px] font-[700] text-[12px] text-white ml-[8px]"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  key: 0,
  class: "logo"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "btn-box"
};
const _hoisted_12 = {
  key: 0,
  target: "_parent",
  href: "/hh88-v1-0811.apk"
};
const _hoisted_13 = {
  class: "download-button mt-[12px] relative"
};
const _hoisted_14 = {
  class: "absolute flex items-center justify-center w-[100%] h-[100%] font-bold text-[18px] text-[#3e0700]"
};
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col item-center justify-center h-full"
};
const _hoisted_16 = ["href"];
const _hoisted_17 = {
  class: "download-button mt-[12px] relative"
};
const _hoisted_18 = {
  class: "absolute flex items-center justify-center w-[100%] h-[100%] text-[18px] text-[#3e0700] font-bold"
};
const _hoisted_19 = {
  class: "btn-box"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "guide-text"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guide-border"
}, null, -1));
const _hoisted_23 = {
  class: "guide-top"
};
const _hoisted_24 = {
  class: "guide-title"
};
const _hoisted_25 = {
  class: "guide-content"
};
const _hoisted_26 = {
  class: "box-text"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_28 = ["src"];
import { computed, onMounted, ref } from "vue";
import $ from "jquery";
import { useI18n } from "vue-i18n";
import { Popup as VanPopup } from "vant";
export default {
  __name: 'MobilePage',
  setup(__props) {
    const homeUrl = ref('https://hh88.com');
    const showLogo = ref(false);
    const showBack = ref(false);
    const {
      locale
    } = useI18n();
    const innerHeight = ref();
    function getLink(i) {
      return require(`@/assets/m/phone-${imgResource[locale.value].guideStep}${i}.webp`);
    }
    const imgResource = {
      'zh-CN': {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-zh/swipe1.png"), require("@/assets/m/phone-zh/swipe2.png"), require("@/assets/m/phone-zh/swipe3.png"), require("@/assets/m/phone-zh/swipe4.png")],
        logo: require("@/assets/m/LOGO_H8.png"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: 'zh/ZH_'
      },
      'zh-HK': {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-tw/swipe1.png"), require("@/assets/m/phone-tw/swipe2.png"), require("@/assets/m/phone-tw/swipe3.png"), require("@/assets/m/phone-tw/swipe4.png")],
        logo: require("@/assets/m/LOGO_H8.png"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: 'tw/ZH_'
      },
      'en': {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-en/swipe1.png"), require("@/assets/m/phone-en/swipe2.png"), require("@/assets/m/phone-en/swipe3.png"), require("@/assets/m/phone-en/swipe4.png")],
        logo: require("@/assets/m/LOGO_H8.png"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: "en/EN_"
      },
      'ms-MY': {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-ms/swipe1.png"), require("@/assets/m/phone-ms/swipe2.png"), require("@/assets/m/phone-ms/swipe3.png"), require("@/assets/m/phone-ms/swipe4.png")],
        logo: require("@/assets/m/LOGO_H8.png"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: "ms/MAS_"
      },
      'vi-VN': {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-vn/swipe1.png"), require("@/assets/m/phone-vn/swipe2.png"), require("@/assets/m/phone-vn/swipe3.png"), require("@/assets/m/phone-vn/swipe4.png")],
        logo: require("@/assets/m/LOGO_H8.png"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: "vn/VN_"
      },
      'hi-IN': {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-in/swipe1.png"), require("@/assets/m/phone-in/swipe2.png"), require("@/assets/m/phone-in/swipe3.png"), require("@/assets/m/phone-in/swipe4.png")],
        logo: require("@/assets/m/LOGO_H8.png"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: "in/IN_"
      }
    };
    onMounted(() => {
      const rate = isIos.value ? 1.714 : 1.6; // 1.6 android
      if ($(window).height() < $(window).width() * rate + 50) {
        showLogo.value = false;
      }
      if (window.location.href.indexOf('show_back=1') !== -1) {
        showBack.value = true;
      }
      innerHeight.value = window.innerHeight;
    });
    function getRandomUrl() {
      // // 定义一个包含四个URL的数组
      const urls = [`/m.hh88pro.com/${locale.value}.mobileconfig`, `/m.hhimain.com/${locale.value}.mobileconfig`, `/m.hhmain.com/${locale.value}.mobileconfig`, `/m.stoneki.com/${locale.value}.mobileconfig`];

      // // 生成一个随机索引
      const randomIndex = Math.floor(Math.random() * urls.length);

      // // 返回随机选中的URL
      return urls[randomIndex];
    }
    function getEnvironment() {
      let ua = navigator.userAgent;
      let result = '';
      if (/AndroidAPP/i.test(ua)) {
        result = 'ANDROIDAPPNEW';
      } else if (/AndroidH5APP/i.test(ua)) {
        result = 'ANDROIDAPP';
      } else if (/android/i.test(ua)) {
        result = 'ANDROID';
      } else if (window.navigator.standalone) {
        result = "WEBCLIP";
      } else if (/(iPhone|iPad|iPod|IOS)/i.test(ua)) {
        result = 'IOS';
      } else {
        // /microMessenger/i.test(ua)
        result = 'ANDROID';
      }
      // Toast('sdf'+ result)
      return result;
    }
    const isIos = computed(() => {
      return getEnvironment() === 'IOS' || getEnvironment() === 'WEBCLIP';
    });
    function cancel() {
      showGuide.value = false;
    }
    const showGuide = ref(false);
    function jumpHome() {
      window.parent.location.href = homeUrl.value;
    }
    function back() {
      window.history.back();
    }
    function trust() {
      setTimeout(function () {
        location.href = "embedded3.mobileprovision";
      }, 3000);
    }
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");
      const _component_van_swipe = _resolveComponent("van-swipe");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "download-page",
        style: _normalizeStyle({
          height: `${innerHeight.value}px` || '100%'
        })
      }, [_createElementVNode("div", _hoisted_1, [showBack.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "back",
        onClick: back
      }, [_createVNode(_component_van_icon, {
        name: "arrow-left",
        color: "var(--color-gray)"
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('message.appDownload')), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", null, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('message.brandInfo')), 1)])]), _createVNode(_component_van_swipe, {
        class: "my-swipe",
        autoplay: 3000,
        "indicator-color": "white"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgResource[_unref(locale)].swipe, (image, index) => {
          return _openBlock(), _createBlock(_component_van_swipe_item, {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              class: "swipe-img",
              src: image
            }, null, 8, _hoisted_8)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), showLogo.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("img", {
        src: imgResource[_unref(locale)].logo,
        class: "logo-img"
      }, null, 8, _hoisted_10)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [!isIos.value ? (_openBlock(), _createElementBlock("a", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('message.downloadBtn')), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("a", {
        target: "_parent",
        onClick: _cache[0] || (_cache[0] = $event => trust()),
        href: getRandomUrl(),
        class: "flex-1 h-full"
      }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('message.downloadNow')), 1)])], 8, _hoisted_16), _unref(locale) === 'vi_VN' ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        target: "_parent",
        onClick: _cache[2] || (_cache[2] = $event => trust()),
        href: "/PP88_nav.mobileconfig",
        class: "flex-1 h-full"
      }, [_createElementVNode("div", {
        class: "mt-[10px] h-[45px] rounded-[24px] bg-[rgba(255,255,255,0.10)] websit-btn text-white flex justify-center items-center text-[14px] font-bold",
        style: {
          "border": "1px solid #707070"
        },
        onClick: _cache[1] || (_cache[1] = $event => jumpHome())
      }, _toDisplayString(_ctx.$t('message.downloadNow2')), 1)])) : _createCommentVNode("", true)]))]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
        class: "mt-[10px] h-[45px] rounded-[24px] bg-[rgba(255,255,255,0.10)] websit-btn text-white flex justify-center items-center text-[14px] font-bold",
        style: {
          "border": "1px solid #707070"
        },
        onClick: _cache[3] || (_cache[3] = $event => jumpHome())
      }, [_createTextVNode(_toDisplayString(_ctx.$t('message.h5')) + " ", 1), _createVNode(_component_van_icon, {
        name: "arrow"
      })])]), isIos.value ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "install-box",
        onClick: _cache[4] || (_cache[4] = $event => showGuide.value = true)
      }, [_createElementVNode("img", {
        class: "top-img",
        src: imgResource[_unref(locale)].top
      }, null, 8, _hoisted_20), _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('message.guideText')), 1)])) : _createCommentVNode("", true)])], 4), _createVNode(_unref(VanPopup), {
        show: showGuide.value,
        "onUpdate:show": _cache[6] || (_cache[6] = $event => showGuide.value = $event),
        position: "bottom",
        class: "guide-popup",
        "safe-area-inset-bottom": true
      }, {
        default: _withCtx(() => [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('message.installGuide')), 1), _createVNode(_component_van_icon, {
          name: "cross",
          onClick: _cache[5] || (_cache[5] = $event => cancel()),
          size: "16px",
          color: "#AAAAAA",
          class: "cancel"
        })]), _createElementVNode("div", _hoisted_25, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, i => {
          return _createElementVNode("div", {
            class: "guide-box",
            key: i
          }, [_createElementVNode("span", _hoisted_26, _toDisplayString(i) + ".", 1), _hoisted_27, _createElementVNode("img", {
            class: "box-img",
            src: getLink(i)
          }, null, 8, _hoisted_28)]);
        }), 64))])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};